export const LinkedInLoginStatus = {
	Succeeded: 'Succeeded',
	ChallengeRequired: 'ChallengeRequired'
} as const

export type LinkedInLoginStatus =
	(typeof LinkedInLoginStatus)[keyof typeof LinkedInLoginStatus]

export const LinkedInLoginChallengeKind = {
	EmailOrSmsPin: 'EmailOrSmsPin',
	EmailPin: 'EmailPin',
	PhoneSmsPin: 'PhoneSmsPin',
	LinkedInApp: 'LinkedInApp',
	LinkedInAppExpired: 'LinkedInAppExpired',
	AuthenticatorApp: 'AuthenticatorApp',
	Captcha: 'Captcha',
	Unknown: 'Unknown'
} as const

export type LinkedInLoginChallengeKind =
	(typeof LinkedInLoginChallengeKind)[keyof typeof LinkedInLoginChallengeKind]

export const LinkedInLoginPhase = {
	Ready: 'ready',
	Submitting: 'submitting',
	Challenge: 'challenge',
	Done: 'done',
	Error: 'error'
} as const

export type LinkedInLoginPhase =
	(typeof LinkedInLoginPhase)[keyof typeof LinkedInLoginPhase]

export const LinkedInLoginResendPinOption = {
	Sms: 'Sms',
	Call: 'Call'
} as const

export type LinkedInLoginResendPinOption =
	(typeof LinkedInLoginResendPinOption)[keyof typeof LinkedInLoginResendPinOption]
